import { TStaffSurveyDataELSA5 } from "../types";

export interface WorkplaceHarassmentFormValues {
  IP_001_genero: string;
  IP_002_edad: string;
  IP_003_comunidad: string;
  IP_004_etnia: string;
  IL_002_turno: string;
  IL_003_tiempoTrabajando: string;
  IL_004_area: string;
  IL_005_contactoConClientes: string;
  IL_006_puestoDeTrabajo: string;
  IL_007_participacionEnComite: string;
  IL_008_jefe: string;
  IL_009_centroDeTrabajo: string;
  SP_001_conocePoliticaDePrevencion: string;
  SP_002_A_C_haSidoCapacitado: string[];
  SP_003_canalDeDenunciasExiste: string;
  SP_012_conoceProcesoDeInvestigacion: string;
  TOL_001AS: string;
  TOL_002AS: string;
  TOL_003AS: string;
  TOL_004AS: string;
  TOL_005AS: string;
  TOL_006AS: string;
  TOL_007AS: string;
  TOL_001AL: string;
  TOL_002AL: string;
  TOL_003AL: string;
  TOL_004AL: string;
  TOL_005AL: string;
  TOL_006AL: string;
  TOL_007AL: string;
  CPT_001: string;
  CPT_002: string;
  CPT_003: string;
  CPT_004: string;
  AT_001_007AS: string[];
  AT_001_007AL: string[];
  FRE_001AS: string;
  FRE_001AL: string;
  PAD_001_002AS: string[];
  PAD_003_007AS: string[];
  PAD_001_002AL: string[];
  PAD_003_007AL: string[];
  AA_001_009AS: string[];
  AA_001_009AL: string[];
  BAD_001_008AS: string[];
  BAD_008AS: string;
  BAD_001_008AL: string[];
  BAD_008AL: string;
  T_001_007AS: string[];
  T_001_007AL: string[];
  ACT_001_008: string[];
  CASE_AS_CASE_RESOLUTION: string;
  CASE_AS_NORMALIZATION: string;
  CASE_AS_VICTIM_RESPONSIBILITY: string;
  CASE_AS_EXACERBATED_INTENT: string;
  CASE_AL_CASE_RESOLUTION: string;
  CASE_AL_NORMALIZATION: string;
  CASE_AL_VICTIM_RESPONSIBILITY: string;
  CASE_AL_EXACERBATED_INTENT: string;
  CON_001: string;
  CON_003: string;
  CON_004: string;
  CON_005: string;
  CON_006: string;
  CON_007: string;
  SAT_001: string;
}

// Utility functions for data transformation
const addToDataIfNotEmpty = (data: any, key: string, value: any) => {
  if (value) data[key.toLowerCase()] = value;
};

const addToDataIfContains = (data: any, list: any, key: string) => {
  if (list.includes(key)) data[key.toLowerCase()] = true;
  else data[key.toLowerCase()] = false;
};

const checkIfCheckboxIsEmpty = (list: string[]) => {
  return list.every((element) => element === "");
};

const addCase = (
  data: any,
  id: number,
  code: string,
  case_resolution: string,
  normalization: string,
  victim_responsibility: string,
  exacerbated_intent: string
) => {
  data[`case_${code}`] = id;
  data[`case_${code}_case_resolution`] = case_resolution;
  data[`case_${code}_normalization`] = normalization;
  data[`case_${code}_victim_responsibility`] = victim_responsibility;
  data[`case_${code}_exacerbated_intent`] = exacerbated_intent;
};

export const transformWorkplaceHarassmentSurveyData = (
  formValues: WorkplaceHarassmentFormValues,
  survey: TStaffSurveyDataELSA5,
  isLeader: boolean,
  esParteDeRecursosHumanos: boolean
) => {
  const data: any = {};

  // Personal Information
  addToDataIfNotEmpty(data, "IP_001", formValues.IP_001_genero);
  addToDataIfNotEmpty(data, "IP_002", formValues.IP_002_edad);
  addToDataIfNotEmpty(data, "IP_003", formValues.IP_003_comunidad);
  addToDataIfNotEmpty(data, "IP_004", formValues.IP_004_etnia);

  // Labor Information
  addToDataIfNotEmpty(data, "IL_003", formValues.IL_003_tiempoTrabajando);
  addToDataIfNotEmpty(data, "IL_005", formValues.IL_005_contactoConClientes);
  addToDataIfNotEmpty(data, "IL_007", formValues.IL_007_participacionEnComite);
  addToDataIfNotEmpty(data, "IL_008", formValues.IL_008_jefe);

  addToDataIfNotEmpty(
    data,
    "IL_002",
    survey.work_shifts.filter(
      (shift) => shift.id === parseInt(formValues.IL_002_turno)
    )[0]?.description
  );
  addToDataIfNotEmpty(data, "WORK_SHIFT", parseInt(formValues.IL_002_turno));

  addToDataIfNotEmpty(
    data,
    "IL_004",
    survey.areas.filter(
      (area) => area.id === parseInt(formValues.IL_004_area)
    )[0]?.description
  );
  addToDataIfNotEmpty(data, "AREA", parseInt(formValues.IL_004_area));

  addToDataIfNotEmpty(
    data,
    "IL_006",
    survey.jobs.filter(
      (job) => job.id === parseInt(formValues.IL_006_puestoDeTrabajo)
    )[0]?.description
  );
  addToDataIfNotEmpty(data, "JOB", parseInt(formValues.IL_006_puestoDeTrabajo));

  const workplace = survey.workplaces.filter(
    (workplace) => workplace.id === parseInt(formValues.IL_009_centroDeTrabajo)
  )[0];
  if (workplace) addToDataIfNotEmpty(data, "IL_009", workplace.description);
  addToDataIfNotEmpty(
    data,
    "WORKPLACE",
    parseInt(formValues.IL_009_centroDeTrabajo)
  );

  // Sexual Prevention
  addToDataIfNotEmpty(
    data,
    "SP_001",
    formValues.SP_001_conocePoliticaDePrevencion
  );
  if (!checkIfCheckboxIsEmpty(formValues.SP_002_A_C_haSidoCapacitado)) {
    addToDataIfContains(
      data,
      formValues.SP_002_A_C_haSidoCapacitado,
      "SP_002A"
    );
    addToDataIfContains(
      data,
      formValues.SP_002_A_C_haSidoCapacitado,
      "SP_002B"
    );
    addToDataIfContains(
      data,
      formValues.SP_002_A_C_haSidoCapacitado,
      "SP_002C"
    );
  }
  addToDataIfNotEmpty(data, "SP_003", formValues.SP_003_canalDeDenunciasExiste);

  addToDataIfNotEmpty(
    data,
    "SP_012",
    formValues.SP_012_conoceProcesoDeInvestigacion
  );

  // Tolerance Sexual Harassment
  addToDataIfNotEmpty(data, "TOL_001AS", formValues.TOL_001AS);
  addToDataIfNotEmpty(data, "TOL_002AS", formValues.TOL_002AS);
  addToDataIfNotEmpty(data, "TOL_003AS", formValues.TOL_003AS);
  addToDataIfNotEmpty(data, "TOL_004AS", formValues.TOL_004AS);
  addToDataIfNotEmpty(data, "TOL_005AS", formValues.TOL_005AS);
  addToDataIfNotEmpty(data, "TOL_006AS", formValues.TOL_006AS);
  addToDataIfNotEmpty(data, "TOL_007AS", formValues.TOL_007AS);

  // Tolerance Workplace Harassment
  addToDataIfNotEmpty(data, "TOL_001AL", formValues.TOL_001AL);
  addToDataIfNotEmpty(data, "TOL_002AL", formValues.TOL_002AL);
  addToDataIfNotEmpty(data, "TOL_003AL", formValues.TOL_003AL);
  addToDataIfNotEmpty(data, "TOL_004AL", formValues.TOL_004AL);
  addToDataIfNotEmpty(data, "TOL_005AL", formValues.TOL_005AL);
  addToDataIfNotEmpty(data, "TOL_006AL", formValues.TOL_006AL);
  addToDataIfNotEmpty(data, "TOL_007AL", formValues.TOL_007AL);

  // Concepts
  addToDataIfNotEmpty(data, "CPT_001", formValues.CPT_001);
  addToDataIfNotEmpty(data, "CPT_002", formValues.CPT_002);
  addToDataIfNotEmpty(data, "CPT_003", formValues.CPT_003);
  addToDataIfNotEmpty(data, "CPT_004", formValues.CPT_004);

  // Harassment Declaration

  if (!checkIfCheckboxIsEmpty(formValues.AT_001_007AS)) {
    addToDataIfContains(data, formValues.AT_001_007AS, "AT_001AS");
    addToDataIfContains(data, formValues.AT_001_007AS, "AT_002AS");
    addToDataIfContains(data, formValues.AT_001_007AS, "AT_003AS");
    addToDataIfContains(data, formValues.AT_001_007AS, "AT_004AS");
    addToDataIfContains(data, formValues.AT_001_007AS, "AT_005AS");
    addToDataIfContains(data, formValues.AT_001_007AS, "AT_006AS");
    addToDataIfContains(data, formValues.AT_001_007AS, "AT_007AS");
  }

  if (!checkIfCheckboxIsEmpty(formValues.AT_001_007AL)) {
    addToDataIfContains(data, formValues.AT_001_007AL, "AT_001AL");
    addToDataIfContains(data, formValues.AT_001_007AL, "AT_002AL");
    addToDataIfContains(data, formValues.AT_001_007AL, "AT_003AL");
    addToDataIfContains(data, formValues.AT_001_007AL, "AT_004AL");
    addToDataIfContains(data, formValues.AT_001_007AL, "AT_005AL");
    addToDataIfContains(data, formValues.AT_001_007AL, "AT_006AL");
    addToDataIfContains(data, formValues.AT_001_007AL, "AT_007AL");
  }

  // Frequency
  addToDataIfNotEmpty(data, "FRE_001AS", formValues.FRE_001AS);
  addToDataIfNotEmpty(data, "FRE_001AL", formValues.FRE_001AL);

  // Harasser Profile
  if (!checkIfCheckboxIsEmpty(formValues.PAD_001_002AS)) {
    addToDataIfContains(data, formValues.PAD_001_002AS, "PAD_001AS");
    addToDataIfContains(data, formValues.PAD_001_002AS, "PAD_002AS");
  }
  if (!checkIfCheckboxIsEmpty(formValues.PAD_003_007AS)) {
    addToDataIfContains(data, formValues.PAD_003_007AS, "PAD_003AS");
    addToDataIfContains(data, formValues.PAD_003_007AS, "PAD_004AS");
    addToDataIfContains(data, formValues.PAD_003_007AS, "PAD_005AS");
    addToDataIfContains(data, formValues.PAD_003_007AS, "PAD_006AS");
    addToDataIfContains(data, formValues.PAD_003_007AS, "PAD_007AS");
  }

  if (!checkIfCheckboxIsEmpty(formValues.PAD_001_002AL)) {
    addToDataIfContains(data, formValues.PAD_001_002AL, "PAD_001AL");
    addToDataIfContains(data, formValues.PAD_001_002AL, "PAD_002AL");
  }
  if (!checkIfCheckboxIsEmpty(formValues.PAD_003_007AL)) {
    addToDataIfContains(data, formValues.PAD_003_007AL, "PAD_003AL");
    addToDataIfContains(data, formValues.PAD_003_007AL, "PAD_004AL");
    addToDataIfContains(data, formValues.PAD_003_007AL, "PAD_005AL");
    addToDataIfContains(data, formValues.PAD_003_007AL, "PAD_006AL");
    addToDataIfContains(data, formValues.PAD_003_007AL, "PAD_007AL");
  }

  // Actions After Harassment
  if (!checkIfCheckboxIsEmpty(formValues.AA_001_009AS)) {
    addToDataIfContains(data, formValues.AA_001_009AS, "AA_001AS");
    addToDataIfContains(data, formValues.AA_001_009AS, "AA_002AS");
    addToDataIfContains(data, formValues.AA_001_009AS, "AA_003AS");
    addToDataIfContains(data, formValues.AA_001_009AS, "AA_004AS");
    addToDataIfContains(data, formValues.AA_001_009AS, "AA_005AS");
    addToDataIfContains(data, formValues.AA_001_009AS, "AA_006AS");
    addToDataIfContains(data, formValues.AA_001_009AS, "AA_007AS");
    addToDataIfContains(data, formValues.AA_001_009AS, "AA_008AS");
    addToDataIfContains(data, formValues.AA_001_009AS, "AA_009AS");
  }

  if (!checkIfCheckboxIsEmpty(formValues.AA_001_009AL)) {
    addToDataIfContains(data, formValues.AA_001_009AL, "AA_001AL");
    addToDataIfContains(data, formValues.AA_001_009AL, "AA_002AL");
    addToDataIfContains(data, formValues.AA_001_009AL, "AA_003AL");
    addToDataIfContains(data, formValues.AA_001_009AL, "AA_004AL");
    addToDataIfContains(data, formValues.AA_001_009AL, "AA_005AL");
    addToDataIfContains(data, formValues.AA_001_009AL, "AA_006AL");
    addToDataIfContains(data, formValues.AA_001_009AL, "AA_007AL");
    addToDataIfContains(data, formValues.AA_001_009AL, "AA_008AL");
    addToDataIfContains(data, formValues.AA_001_009AL, "AA_009AL");
  }

  // Barriers to Reporting
  if (!checkIfCheckboxIsEmpty(formValues.BAD_001_008AS)) {
    addToDataIfContains(data, formValues.BAD_001_008AS, "BAD_001AS");
    addToDataIfContains(data, formValues.BAD_001_008AS, "BAD_002AS");
    addToDataIfContains(data, formValues.BAD_001_008AS, "BAD_003AS");
    addToDataIfContains(data, formValues.BAD_001_008AS, "BAD_004AS");
    addToDataIfContains(data, formValues.BAD_001_008AS, "BAD_005AS");
    addToDataIfContains(data, formValues.BAD_001_008AS, "BAD_006AS");
    addToDataIfContains(data, formValues.BAD_001_008AS, "BAD_007AS");

    const bad_list_as: string[] = formValues.BAD_001_008AS;
    if (bad_list_as.includes("BAD_008AS"))
      addToDataIfNotEmpty(data, "BAD_008AS", formValues.BAD_008AS);
  }

  if (!checkIfCheckboxIsEmpty(formValues.BAD_001_008AL)) {
    addToDataIfContains(data, formValues.BAD_001_008AL, "BAD_001AL");
    addToDataIfContains(data, formValues.BAD_001_008AL, "BAD_002AL");
    addToDataIfContains(data, formValues.BAD_001_008AL, "BAD_003AL");
    addToDataIfContains(data, formValues.BAD_001_008AL, "BAD_004AL");
    addToDataIfContains(data, formValues.BAD_001_008AL, "BAD_005AL");
    addToDataIfContains(data, formValues.BAD_001_008AL, "BAD_006AL");
    addToDataIfContains(data, formValues.BAD_001_008AL, "BAD_007AL");

    const bad_list_al: string[] = formValues.BAD_001_008AL;
    if (bad_list_al.includes("BAD_008AL"))
      addToDataIfNotEmpty(data, "BAD_008AL", formValues.BAD_008AL);
  }

  // Witness harrasment
  if (!checkIfCheckboxIsEmpty(formValues.T_001_007AS)) {
    addToDataIfContains(data, formValues.T_001_007AS, "T_001AS");
    addToDataIfContains(data, formValues.T_001_007AS, "T_002AS");
    addToDataIfContains(data, formValues.T_001_007AS, "T_003AS");
    addToDataIfContains(data, formValues.T_001_007AS, "T_004AS");
    addToDataIfContains(data, formValues.T_001_007AS, "T_005AS");
    addToDataIfContains(data, formValues.T_001_007AS, "T_006AS");
    addToDataIfContains(data, formValues.T_001_007AS, "T_007AS");
  }

  if (!checkIfCheckboxIsEmpty(formValues.T_001_007AL)) {
    addToDataIfContains(data, formValues.T_001_007AL, "T_001AL");
    addToDataIfContains(data, formValues.T_001_007AL, "T_002AL");
    addToDataIfContains(data, formValues.T_001_007AL, "T_003AL");
    addToDataIfContains(data, formValues.T_001_007AL, "T_004AL");
    addToDataIfContains(data, formValues.T_001_007AL, "T_005AL");
    addToDataIfContains(data, formValues.T_001_007AL, "T_006AL");
    addToDataIfContains(data, formValues.T_001_007AL, "T_007AL");
  }

  // Actions as Witness
  if (!checkIfCheckboxIsEmpty(formValues.ACT_001_008)) {
    addToDataIfContains(data, formValues.ACT_001_008, "ACT_001");
    addToDataIfContains(data, formValues.ACT_001_008, "ACT_002");
    addToDataIfContains(data, formValues.ACT_001_008, "ACT_003");
    addToDataIfContains(data, formValues.ACT_001_008, "ACT_004");
    addToDataIfContains(data, formValues.ACT_001_008, "ACT_005");
    addToDataIfContains(data, formValues.ACT_001_008, "ACT_006");
    addToDataIfContains(data, formValues.ACT_001_008, "ACT_008");
  }

  // Cases for Leaders and HR
  if (isLeader || esParteDeRecursosHumanos) {
    addCase(
      data,
      survey.cases.first.id,
      "as",
      formValues.CASE_AS_CASE_RESOLUTION,
      formValues.CASE_AS_NORMALIZATION,
      formValues.CASE_AS_VICTIM_RESPONSIBILITY,
      formValues.CASE_AS_EXACERBATED_INTENT
    );
    addCase(
      data,
      survey.cases.second.id,
      "al",
      formValues.CASE_AL_CASE_RESOLUTION,
      formValues.CASE_AL_NORMALIZATION,
      formValues.CASE_AL_VICTIM_RESPONSIBILITY,
      formValues.CASE_AL_EXACERBATED_INTENT
    );
  }

  // Confidence in Organization
  addToDataIfNotEmpty(data, "CON_001", formValues.CON_001);
  addToDataIfNotEmpty(data, "CON_007", formValues.CON_007);
  addToDataIfNotEmpty(data, "CON_003", formValues.CON_003);
  addToDataIfNotEmpty(data, "CON_004", formValues.CON_004);
  addToDataIfNotEmpty(data, "CON_005", formValues.CON_005);
  addToDataIfNotEmpty(data, "CON_006", formValues.CON_006);

  // Satisfaction
  addToDataIfNotEmpty(data, "SAT_001", formValues.SAT_001);

  return data;
};
